<template>
  <section class="login">
  </section>
</template>

<script>
export default {
  mounted() {
    this.login()
  },
  methods: {
    async login() {
      await this.$store
        .dispatch("auth/loginBySso", {
          ...this.$route.query,
          type: this.$route.params.type,
        })
        .then(() => {
          this.$router.push({
            name: "DashboardJump",
            params: { org_code: this.$store.state.auth.user.current_organization.code },
          });
        })
        .catch((error) => {
          console.error(error);
          this.$swal("失敗", error.response.data.message, "error").then(() => {
            this.$router.push({ name: 'AuthLogin' })
          });
        });
    },
  },
};
</script>
